module.exports = __webpack_public_path__ + "img/start-icon.90c1aee7.png";